import { render } from "./DarkOverlay.vue?vue&type=template&id=c58e9572&scoped=true"
import script from "./DarkOverlay.vue?vue&type=script&lang=js"
export * from "./DarkOverlay.vue?vue&type=script&lang=js"

import "./DarkOverlay.vue?vue&type=style&index=0&id=c58e9572&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c58e9572"]])

export default __exports__